import React, { useState } from 'react';
import { TextField } from '@mui/material';
import ConfirmDialog from '../../../shared/components/ConfirmDialog';

interface Props {
  open: boolean;
  /** Named, because this is also opened from a list where the run is not otherwise identified. */
  runTitle: string;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
}

// One home for the rule that abandoning costs a reason. It is asked from three places now (the
// open run, a stranded run's record, and a sidebar row), and a second copy of the dialog is how
// one of them ends up quietly abandoning without one.
const WorkflowAbandonDialog: React.FC<Props> = ({ open, runTitle, onCancel, onConfirm }) => {
  const [reason, setReason] = useState('');
  const [missing, setMissing] = useState(false);

  const close = () => {
    setMissing(false);
    onCancel();
  };

  return (
    <ConfirmDialog
      open={open}
      title={`Abandon ${runTitle}?`}
      onCancel={close}
      onConfirm={() => {
        if (!reason.trim()) {
          setMissing(true);
          return;
        }
        setMissing(false);
        const given = reason.trim();
        setReason('');
        onConfirm(given);
      }}
      confirmText="Abandon run"
      confirmColor="error"
    >
      The run stops for good and keeps what it recorded so far. The agent is told why.
      <TextField
        fullWidth
        required
        size="small"
        label="Reason"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        error={missing && !reason.trim()}
        helperText="Required: why the run is being stopped"
        sx={{ mt: 2 }}
      />
    </ConfirmDialog>
  );
};

export default WorkflowAbandonDialog;
